// Point d'entrée assemblé par esbuild (jsbundling-rails) dans
// app/assets/builds/application.js. Tout ce qui est importé ici est un vrai paquet
// npm (voir package.json) : aucune balise <script> de CDN dans les layouts.
import { Turbo } from "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
window.bootstrap = bootstrap

import { initTableLists } from "./admin/table_list"
import { confirmWithModal } from "./admin/confirm_modal"

// Toute action portant data-turbo-confirm="..." passe par la fenêtre de
// confirmation du layout d'administration plutôt que par le confirm() natif.
Turbo.config.forms.confirm = confirmWithModal

// Rejoué à chaque visite Turbo ; chaque initialisation ignore ce qu'elle a déjà câblé.
document.addEventListener("turbo:load", () => {
  initTableLists()
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => bootstrap.Tooltip.getOrCreateInstance(el))
})
